import axiosBase from "../utils/axios/axios";

export const listParams = async (number, page=1) => {
  try {
    const response = await axiosBase.get(
      `/utils/parametro-detalle/?page=${page}&parametro_id=${number}`
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const listTypeDocument = async()=>{
  try {
    const response = await axiosBase.get(
      `/personas/tipos-documento/`
    );
    return response.data;
  } catch (error) {
    throw error;
  }
}


